<template>
  <div class="steps">
    <div class="step" :class="current == 1 ? 'current' : ''">
      <img
        src="@/assets/images/order/step-end@3x.png"
        v-if="current > 1"
        style="width: 32px"
      />
      <span v-else class="number">1</span>
      <span>确认订单</span>
    </div>
    <div class="line line-1"></div>
    <div class="step" :class="current == 2 ? 'current' : ''">
      <span class="number">2</span>
      <span>支付</span>
    </div>
    <div class="line line-2"></div>
    <div class="step" :class="current == 3 ? 'current' : ''">
      <span class="number">3</span>
      <span>完成</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderStep",
  props: {
    current: {
      type: Number,
      default: 1,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";

.steps {
  background-color: white;
  padding: 24px;
  display: flex;
  align-items: center;
  .step {
    color: #666666;
    font-size: 16px;
    .number {
      display: inline-block;
      width: 32px;
      height: 32px;
      border-radius: 100%;
      border: 1px solid rgba(0, 0, 0, 0.15);
      text-align: center;
      line-height: 30px;
      color: rgba(0, 0, 0, 0.25);
      margin-right: 8px;
      box-sizing: border-box;
    }
    img,
    span {
      vertical-align: middle;
    }
    img {
      margin-right: 8px;
    }
  }
  .current {
    color: #333;
    font-family: PingFangSC-Medium;
    font-weight: 500;

    .number {
      background-color: $primary-color;
      border: 1px solid $primary-color;
      color: white;
    }
  }
  .line {
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
    margin: 0 16px;
  }
  .line-1 {
    width: 388px;
  }
  .line-2 {
    flex: 1;
  }
}
</style>
